<template>
  <div>
    <header class="header">
      <div class="header-top">
        <div class="navbar navbar-expand-md navbar-light">
        <a class="header-logo font-weight-bold" :href="!isWarehouseUser ? '/' : '/shipping-instructions'">{{translations('header.title')}}</a>
        <p class="header-logo ml-2 mt-3" style="color: red; font-size:medium; font-weight: bold">{{version}}</p>
        <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
        <ul v-if="isLogged || isWarehouseUser" class="nav align-items-center">
          <li class="nav-item">
            <div class="dropdown">
              <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ languageOptions[currentLanguage] }}
              </button>
              <div class="dropdown-menu">
                <button class="dropdown-item" type="button" value="ja" @click="changeLanguage('ja')">{{ languageOptions.ja }}</button>
                <button class="dropdown-item" type="button" value="en" @click="changeLanguage('en')">{{ languageOptions.en }}</button>
                <button class="dropdown-item" type="button" value="zh" @click="changeLanguage('zh')">{{ languageOptions.zh }}</button>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div v-if="!isWarehouseUser" class="dropdown">
              <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{companyNames}}
              </button>
              <div class="dropdown-menu">
                <button class="dropdown-item" type="button" data-toggle="modal" data-target="#EditAboutModal">{{translations('header.setting_information_company')}}</button>
                <router-link class="dropdown-item" to="/archive-users">{{translations('header.setting_users')}}</router-link>
                <router-link v-if="isAdmin" class="dropdown-item" to="/single-users">{{translations('header.register_user')}}</router-link>
                <router-link class="dropdown-item" to="/archive-warehouse-users">{{translations('header.warehouse_users')}}</router-link>
              </div>
            </div>
            <div v-else class="dropdown">
              <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{warehouseCompanyName}}
              </button>
              <div class="dropdown-menu">
                <router-link class="dropdown-item" to="/single-warehouse-users">{{translations('header.change_user_information')}}</router-link>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" v-on:click="logout">{{translations('header.log_out')}}</a>
          </li>
        </ul>
        </div>
        </div>
      </div>
      <div v-if="isLogged || isWarehouseUser" class="header-bottom container-fluid d-flex align-items-center">
        <ul v-if="!isWarehouseUser" class="nav align-items-center">
          <li class="nav-item">
            <router-link class="header-bottom-btn" to="/"><i class="fas fa-home"></i></router-link>
          </li>
          <li class="nav-item">
            <div class="dropdown hover">
              <button class="btn header-bottom-btn dropdown-toggle font-weight-bold" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-clipboard-list"></i>
                {{translations('navbar.sale_management')}}
              </button>
              <div class="dropdown-menu">
                <router-link class="dropdown-item" to="/new-estimates">{{translations('navbar.register_estimate')}}</router-link>
                <router-link class="dropdown-item" to="/archive-estimates">{{translations('navbar.archive_estimate')}}</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/new-orders">{{translations('navbar.register_order')}}</router-link>
                <router-link class="dropdown-item" to="/archive-orders">{{translations('navbar.archive_order')}}</router-link>
                <div class="dropdown-divider"></div>
<!--                <router-link class="dropdown-item" to="/new-reserves">{{translations('navbar.register_reserve')}}</router-link>-->
                <router-link class="dropdown-item" to="/archive-reserves">{{translations('navbar.archive_reserve')}}</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/archive-sales">{{translations('navbar.archive_shipment')}}</router-link>
                <router-link class="dropdown-item" to="/shipping-instructions">{{translations('navbar.shipping_instruction')}}</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/archive-invoices">{{translations('navbar.archive_invoice')}}</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/archive-payments">{{translations('navbar.archive_deposit')}}</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/archive-accounts-receivable">{{translations('navbar.archive_accounts_receivable')}}</router-link>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div class="dropdown hover">
              <button class="btn header-bottom-btn dropdown-toggle font-weight-bold" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-truck-moving"></i>
                {{translations('navbar.purchase_management')}}
              </button>
              <div class="dropdown-menu">
                <router-link class="dropdown-item" to="/new-purchases">{{translations('navbar.register_purchase')}}</router-link>
                <router-link class="dropdown-item" to="/archive-purchases">{{translations('navbar.archive_purchase')}}</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/archive-purchase-stockings">{{translations('navbar.archive_arrival')}}</router-link>
                <router-link class="dropdown-item" to="/archive-purchase-overseas-stockings">{{translations('navbar.archive_oversea_shipment')}}</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/archive-purchase-payments">{{translations('navbar.archive_payment')}}</router-link>
                <div class="dropdown-divider"></div>
<!--                 <router-link class="dropdown-item" to="/archive-withdrawal">出金の一覧</router-link>
                <div class="dropdown-divider"></div> -->
                <router-link class="dropdown-item" to="/archive-accounts-payable">{{translations('navbar.archive_account_payable')}}</router-link>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div class="dropdown hover">
              <button class="btn header-bottom-btn dropdown-toggle font-weight-bold" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-cubes"></i>
                {{translations('navbar.inventory_control')}}
              </button>
              <div class="dropdown-menu">
                <router-link class="dropdown-item" to="/archive-stock">{{translations('navbar.archive_inventory')}}</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/inout-details">{{translations('navbar.goods_receipt_issue_detail')}}</router-link>
                <div class="dropdown-divider"></div>
                <div class="dropdown hover dropdown-item">
                  <div class="dropdown-toggle dropdown-child" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{translations('navbar.inventory')}}
                  </div>
                  <div class="dropdown-menu dropdown-child-menu">
                    <router-link class="dropdown-item" to="/check-inventories">{{translations('navbar.inventory_entry')}}</router-link>
                    <router-link class="dropdown-item" to="/inventories">{{translations('navbar.inventories')}}</router-link>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div class="dropdown hover">
              <button class="btn header-bottom-btn dropdown-toggle font-weight-bold" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-redo"></i>
                {{translations('navbar.return_management')}}
              </button>
              <div class="dropdown-menu">
                <router-link class="dropdown-item" to="/new-return">{{translations('navbar.corporate_return_processing')}}</router-link>
                <router-link class="dropdown-item" to="/archive-return">{{translations('navbar.archive_return')}}</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/new-replacement">{{translations('navbar.user_exchange_process')}}</router-link>
                <router-link class="dropdown-item" to="/archive-replacement">{{translations('navbar.archive_replacement_parts')}}</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/new-consignment-return">{{translations('navbar.consignment_return_processing')}}</router-link>
                <router-link class="dropdown-item" to="/archive-consignment-return">{{translations('navbar.archive_consignment_returns')}}</router-link>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div class="dropdown hover">
              <button class="btn header-bottom-btn dropdown-toggle font-weight-bold" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-coins"></i>
                {{translations('navbar.budget_control')}}
              </button>
              <div class="dropdown-menu">
                <router-link class="dropdown-item" to="/new-budget">{{translations('navbar.register_budget')}}</router-link>
                <router-link class="dropdown-item" to="/archive-budget">{{translations('navbar.archive_budget')}}</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/cost-budget">{{translations('navbar.enter_shipping_cost')}}</router-link>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div class="dropdown hover">
              <button class="btn header-bottom-btn dropdown-toggle font-weight-bold" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-chart-line"></i>
                {{translations('navbar.various_tallies')}}
              </button>
              <div class="dropdown-menu">
                <router-link class="dropdown-item" to="/dashboard">{{translations('navbar.sales_tally')}}</router-link>
                <!-- <router-link class="dropdown-item" to="#!">受注残集計</router-link> -->
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div class="dropdown hover">
              <button class="btn header-bottom-btn dropdown-toggle font-weight-bold" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-cogs"></i>
                {{translations('navbar.setting')}}
              </button>
              <div class="dropdown-menu">
                <button class="dropdown-item" type="button" data-toggle="modal" data-target="#EditUserModal">{{translations('navbar.account_setting')}}</button>
                <button class="dropdown-item" type="button" data-toggle="modal" data-target="#EditPasswordModal">{{translations('navbar.change_password')}}</button>
                <button class="dropdown-item" type="button" data-toggle="modal" data-target="#EditBankModal">銀行情報の設定</button>
              </div>
            </div>
          </li>
          <li class="nav-item">
            <div class="dropdown hover">
              <button class="btn header-bottom-btn font-weight-bold" type="button" @click="$router.push('/edi-tool')">
                <i class="fas fa-cogs"></i>
                {{translations('navbar.edi_tool')}}
              </button>
            </div>
          </li>
          <li class="nav-item">
            <div class="dropdown hover">
              <button class="btn header-bottom-btn font-weight-bold" type="button" @click="$router.push('/amazon-payrecv')">
                <i class="fas fa-cogs"></i>
                {{translations('navbar.amazon_accounts_payable_management')}}
              </button>
            </div>
          </li>
        </ul>
        <ul v-else class="nav align-items-center">
          <li class="nav-item">
            <div class="dropdown hover">
              <button class="btn header-bottom-btn font-weight-bold" type="button" @click="$router.push('/shipping-instructions')">
                <i class="fas fa-clipboard-list"></i>
                {{translations('navbar.shipping_instruction')}}
              </button>
            </div>
          </li>
        </ul>
      </div>
    </header>

    <EditAboutModal v-if="isLogged" :companyNames='companyName' />
    <EditUserModal v-if="isLogged"/>
    <EditPasswordModal v-if="isLogged"/>
    <EditBankModal v-if="isLogged"/>
  </div>
</template>

<script>
import EditAboutModal from '@/components/users/EditAboutModal'
import EditUserModal from '@/components/users/EditUserModal'
import EditPasswordModal from '@/components/users/EditPasswordModal'
import EditBankModal from '@/components/users/EditBankModal'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'appHeader',
  props: ['headerType'],
  components: {
    EditAboutModal,
    EditUserModal,
    EditPasswordModal,
    EditBankModal
  },
  data () {
    return {
      title: '慎太郎',
      companyName: [],
      isLoading: false,
      isLoginPage: false,
      versionDeploys: [],
      version: '',
      apiUrl: process.env.VUE_APP_SHINTARO_API_URL
    }
  },
  watch: {
    isLogged (v) {
      if (v) {
        this.getInitData() // FOR REFRESH
      }
    }
  },
  async created () {
    console.log('Header::created')
    if (this.$route.name !== 'login' && this.$route.name !== 'login-reset' && this.$route.name !== 'warehouse-login' && this.$route.name !== 'warehouse-password-reset') {
      if (!this.isLogged && !this.isWarehouseUser) {
        location.href = '/login'
      }
    }
    if (this.isLogged) {
      await this.getInitData() // FOR REFRESH
      this.getVersionDeploy()
    }
  },
  mounted () {
  },
  computed: {
    isLogged: function () {
      return this.$store.getters['User/isLogged']
    },
    isWarehouseUser: function () {
      return this.$store.getters['WarehouseUser/isLogged']
    },
    isAdmin: function () {
      return this.$store.getters['User/isAdmin']
    },
    companyNames: function () {
      return this.companyName[0]
    },
    warehouseCompanyName: function () {
      return this.$store.getters['WarehouseUser/companyName']
    },
    ...mapState(['currentLanguage', 'languageOptions'])
  },
  methods: {
    ...mapActions(['changeLanguage']),
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    async getInitData () {
      if (!this.isLogged) return // SKIP

      let self = this
      try {
        self.isLoading = true

        let result = await this.$http.post(this.$api_url.account_company)
        if (result.data.status === true) {
          this.companyName.shift() // REMOVE OLD
          this.companyName.push(result.data.details.company_name)
        } else {
          self.$toastr.error(result.data.message, 'エラー')
        }
        self.isLoading = false
      } catch (error) {
        self.isLoading = false
        // self.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        console.log('account:company:catch(error): ', error)
      }
    },

    async logout () {
      try {
        this.isLoading = true

        let result = await this.$http.post(this.$api_url.account_logout)
        if (result.data.status !== true) {
          console.error('エラー', result.message)
        } else {
          this.$session.removeAll()
        }
      } catch (error) {
        console.error('account:logout:catch(error): ', error)
      } finally {
        this.isLoading = false
        if (!this.isWarehouseUser) {
          this.$store.dispatch('User/logout').then(() => {
            this.$router.push('/login')
          })
        } else {
          this.$store.dispatch('WarehouseUser/logout').then(() => {
            this.$router.push('/warehouse-login')
          })
        }
      }
    },

    getVersionDeploy () {
      this.isLoading = true
      this.$http.get(this.$api_url.version_deploy).then(response => {
        const result = response.data
        if (result.status === true) {
          this.versionDeploys = result.list
          result.list.forEach(versionDeploy => {
            if (this.apiUrl === versionDeploy.key) {
              this.version = versionDeploy.value
            }
          })
        } else {
          this.versionDeploys = []
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(error => {
        console.log('GetVersionDeploy: error: ', error)
        this.isEmptyMsg = 'エラーのため失敗しました。ご確認後、再試行してください。'
        this.$toastr.error(this.isEmptyMsg, 'エラー')
      }).finally(() => {
        this.isSearching = false
      })
    }
  }
}
</script>
